// E-İmza zorunluluk tarihi: 01.04.2026
// Bu tarihten önce uyarı gösterilir, sonra zorunlu hale gelir.
export const EIMZA_DEADLINE = new Date('2026-04-01T00:00:00');

// Pilot test kullanıcıları: deadline gelmemiş olsa bile bu ID'lere e-imza zorunlu tutulur.
// Yeni test kullanıcısı eklemek için buraya ID'sini ekle.
export const EIMZA_PILOT_USER_IDS = [
  36171
];

export function isBeforeDeadline() {
  return new Date() < EIMZA_DEADLINE;
}

export function isEimzaRequired(userId) {
  if (!isBeforeDeadline()) return true;
  return EIMZA_PILOT_USER_IDS.includes(userId);
}
